/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import Hidden from "@mui/material/Hidden";
import FormFader from "../Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import NumberFieldConfigured from "../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type FinanceProps = {
  submitProps: FormSubmitProps;
};
export default function Finance({ submitProps }: FinanceProps) {
  const { handleSubmit, values } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm }} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Finanzen
            </Typography>
          </Hidden>
          <Typography variant={"h4"} sx={wizardStyle.subheadline}>
            Nettoeinkommen
          </Typography>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
              <FormLegend>
                Wie viel verdienen Sie und Ihr Expartner netto pro Monat? Anhand dieser Angaben können Sie frühzeitig erfahren, welche Kosten bei einer
                Scheidung auf Sie zukämen. Das Gericht ermittelt später anhand der Einkommen den Verfahrenswert der Scheidung und setzt so die Kosten fest.
              </FormLegend>
            </Grid>
            <NumberFieldConfigured caseData={values} fieldPath={"netIncomePetitioner"} fieldType={"money"} required={true} />
            <NumberFieldConfigured caseData={values} fieldPath={"netIncomePartner"} fieldType={"money"} required={true} />
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
